<style lang="scss" >


</style>

<template>

<div class="wrapper antialiased">
    <Header></Header>
    <div class="page-wrapper">
        <router-view></router-view>
    </div>
    <Footer></Footer>
</div>

</template>

<script>

import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';

export default {
  name: 'Base',
  data: function () {
        return {
        
        }
    },
  components: {
      Header,
      Footer
  }
}
</script>